import { Country } from '@/types/country';
import { KindFish } from '@/types/kind-fish';
import { Tare } from '@/types/tare';
import { TypeCutting } from '@/types/type-cutting';

import { SizeList } from '../reference-data';
import { RequestService } from '../services/request.service';

export type GetFishSaleFilterResponse = {
	/** Локации складов */
	location?: string[];
	/** Виды рыб */
	kind_fish?: KindFish[];
	/** Виды разделки */
	type_cutting?: TypeCutting[];
	/** Производители */
	product_manufacturer?: string[];
	/** Районы промысла TODO: уточнить после реализации */
	fishing_area?: string[];
	/** Тары */
	tare?: Tare[];
	/** Размер */
	size?: SizeList;
	/** Типы глубокой переработки TODO: уточнить после реализации */
	deep_processing?: string[];
	/** Страны */
	countries?: Country[];
	/** Страны */
	one_piece_weights?: number[];
	/** Список складов */
	warehouses?: {
		id: string;
		title: string;
	}[];
};

/**
 * Получает параметры для фильтров на странице "Купить рыбу"
 */
export async function getFishSaleFilter() {
	const request = RequestService.getInstance();
	try {
		const { data } = await request.get<GetFishSaleFilterResponse>(
			`${process.env.HOST}/api_v1/fish-sale-filter/`,
		);

		return data;
	} catch (error) {
		throw new Error(
			error.response?.data?.message ?? error?.statusText ?? 'Произошла ошибка при получении данных',
		);
	}
}
